<div class="input-container" [class.disabled]="isDisabled">
  <qr-icon
    *ngIf="config.icon"
    [name]="config.icon"
    [color]="getIconColor()"
    class="input-icon"
  ></qr-icon>
  <input
    #nativeInput
    [(ngModel)]="visibleValue"
    (ngModelChange)="modelChange($event)"
    [type]="this.config?.type ? this.config?.type : 'text'"
    [placeholder]="config.placeholder ? config.placeholder : ''"
    [style.height.px]="config.size"
    class="{{ config.hierarchy }}"
    autocomplete="off"
    [attr.disabled]="isDisabled ? true : null"
    [class.error]="hasError"
    (keydown)="keydown($event)"
    (paste)="onDecimalPaste($event)"
    (focusout)="focusout($event)"
    [ngClass]="{ iconMode: config.icon }"
    [maxlength]="config.maxLength || null"
    (blur)="blurChange.emit(true)"
    (focus)="focusIn.emit(true)"
  />
  <qr-button
    *ngIf="
      config.isCleanButtonVisible &&
      this.visibleValue &&
      this.visibleValue.toString().length > 0
    "
    [config]="buttonClear"
    class="button-clear"
    (click)="clear()"
    [isDisabled]="isDisabled"
  ></qr-button>
  <qr-button
    *ngIf="config.isTogglePasswordVisible"
    [config]="buttonTogglePassword"
    class="button-toggle-password"
    (click)="togglePassword()"
  ></qr-button>
</div>
<div class="hints" *ngIf="(config.hint || config.hintRight) && !hasError">
  <span class="hint" *ngIf="config.hint">{{ config.hint }}</span>
  <span class="hint hint--right" *ngIf="config.hintRight">{{
    config.hintRight
  }}</span>
</div>
<span class="error-msg" *ngIf="config.errorMsg && hasError">{{
  config.errorMsg
}}</span>
